




$(document).ready(function () {
    function selectedVarint() {
        var slectedId = $(".selected-product").val();
        var url = new URL(window.location.href);
        url.searchParams.set("variant", slectedId);
        window.history.replaceState({}, "", url);
    }
    function selectedUpdate() {
        var updateValue = "";
        $(".h-flex input[type='radio']:checked").each(
            function () {
                updateValue += (updateValue ? " / " : "") + $(this).val();
            
            }
        );
        $(".selected-product option").each(function () {
            var optionValue = $(this).text().trim();
            if (optionValue == updateValue) {
                $(this).prop("selected", true);
                // console.log(optionValue);
                return true;
            }
        });
    }
    $(".h-flex input[type='radio']").change(function () {
        selectedUpdate();
        selectedVarint();
        

    });
    selectedUpdate();
});


function rendering() {
    fetch("?section_id=cart-component")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".cart-right__render", cart__html);
            $(".cart-right__render").replaceWith(render__html);
        });
    fetch("?section_id=cart-component")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".nav-cart_total-text_sunshine", cart__html);
            $(".nav-cart_total-text_sunshine").replaceWith(render__html);
        });


    fetch("?section_id=nav-component")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".nav-cart_total-text", cart__html);
            $(".nav-cart_total-text").replaceWith(render__html);
        });
}




function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    value = isNaN(value) ? 0 : value
    value++;
    // console.log(input);
   
    input.value = value;
    changeQuantity(input)
 
}
function decrement(el) {
    var input = el.nextElementSibling;
    // console.log(input);
    var value = parseInt(input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
        changeQuantity(input)

       
    }
}
function changeQuantity(input) {
    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    // console.log(quantity);
    var data = {
        "line": data_line,
        "quantity": quantity

    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            // console.log(data);
            rendering();
        },
        error: function (err) {
            console.log("Error from quantity update")
        }
    })
}

// remove item form cart
function itemRemove(e, el) {
    e.preventDefault();

    var data_line = $(el).attr("data-line");

    var data = {
        "line": data_line,
        "quantity": 0
    }
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            rendering()
        }
    })
}